var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var KeyStarIcon = function () {
    return (_jsx("svg", __assign({ width: "12", height: "13", viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M3 0C1.33333 0 0 1.33333 0 3C0 4.66667 1.33333 6 3 6C4.33333 6 5.4 5.2 5.8 4H8V6H10V4H12V2H5.8C5.4 0.8 4.33333 0 3 0ZM3 2C3.53333 2 4 2.46667 4 3C4 3.53333 3.53333 4 3 4C2.46667 4 2 3.53333 2 3C2 2.46667 2.46667 2 3 2ZM6 7.33333L5.26667 9.06667L3.33333 9.26667L4.8 10.5333L4.33333 12.4L6 11.4L7.6 12.4L7.2 10.5333L8.66667 9.26667L6.73333 9.13333L6 7.33333Z", fill: "#4F46E5" }) })));
};
export default KeyStarIcon;
